/**
 * Resolve the current user's access token using the same strategy as the
 * Apollo auth link: Teams SSO first, then MSAL silent acquisition.
 *
 * Returns null when no user is authenticated or acquisition fails.
 */

import { msalInstance, apiRequest } from "./msal-config";
import { isInTeams, getTeamsToken } from "./teams-auth";

export async function getAuthToken(): Promise<string | null> {
  try {
    if (await isInTeams()) {
      const token = await getTeamsToken();
      if (token) return token;
    }

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) return null;

    const response = await msalInstance.acquireTokenSilent({
      ...apiRequest,
      account: accounts[0],
    });
    return response.accessToken || null;
  } catch {
    return null;
  }
}
